module.exports = __webpack_public_path__ + "img/DS-M-1.1f2b87f0.svg";